<template>
    <section>
        <!-- <div class="rC"><div class="rSC">
	        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.77220950822!2d126.95528431573746!3d37.37156647983489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b6755947b14d3%3A0x4fa3b3ab2668672d!2z66CI64W467KE7JWI7JaR7IS87YSw!5e0!3m2!1sko!2skr!4v1565828000992!5m2!1sko!2skr" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div></div> -->


        <!-- <div class="mapouter">
            <div class="gmap_canvas">                
                <iframe width="800" height="800" id="gmap_canvas" src="https://maps.google.com/maps?q=2880%20Broadway,%20New%20York&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>        
                </div></div> -->
                
                <!-- <script type="text/javascript" src="//dapi.kakao.com/v2/maps/sdk.js?appkey=5653d3204f81e1b28c18f700cb78a480"></script> -->
                

                    <vue-daum-map
      :appKey="appKey"
      :center.sync="center"
      :level.sync="level"
      :mapTypeId="mapTypeId"
      :libraries="libraries"
      @load="onLoad"
      @center_changed=""
      @zoom_start=""
      @zoom_changed=""
      @bounds_changed=""
      @click=""
      @dblclick=""
      @rightclick=""
      @mousemove=""
      @dragstart=""
      @drag=""
      @dragend=""
      @idle=""
      @tilesloaded=""
      @maptypeid_changed=""
      style="width:100%;height:400px;"/>
      
    </section>
</template>

<script>
    import loginService from '../services/loginService'
    import VueDaumMap from 'vue-daum-map'   
    import { useRoute } from 'vue-router'
    
    export default {
        name: "Map",
        components: {
            VueDaumMap,
        },
        data: () => ({
            appKey: '5653d3204f81e1b28c18f700cb78a480',
            center: {lat:33.450701, lng:126.570667}, // 지도의 중심 좌표
            //center: {lat:33.450701, lng:this.$route.query.x}, // 지도의 중심 좌표
            //center: {lat:parseFloat(this.$route.query.y), lng:parseFloat(this.$route.query.x)}, // 지도의 중심 좌표
            level: 3, // 지도의 레벨(확대, 축소 정도),
            mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
            libraries: [], // 추가로 불러올 라이브러리
            map: null, // 지도 객체. 지도가 로드되면 할당됨.
            daum: null, // 다음 API 객체. 지도가 로드되면 할당됨.
        }),
        methods: {
            async login() {
                if(!this.username || !this.password)
                    return;

                const result = await loginService.login(this.username, this.password);
                if (result.r) {
                    this.success = true;
                    this.loginErrorMsg = '';
                } else {
                    this.success = false;
                    this.loginErrorMsg = result.msg;
                }
                console.log(result)

            },
            async update() {
                const route = useRoute()
                const { query } = route;
                this.center = {lat:query.y, lng:query.x}
                console.log('aaaa');

            },
            onLoad (map, daum) {
                this.map = map;
                this.daum = daum;

                new kakao.maps.Marker({
                    //position: new kakao.maps.LatLng(33.450701, 126.570667),
                    position: map.getCenter(), 
                    map: map
                });
            },
        },
        async mounted() {
            this.update();
        },
    }
</script>

<style scoped>

</style>
